import { Avatar, Stack, Typography } from "@mui/material";
import moment from "moment";
import React from "react";
import appcolors from "../../constants/Colors";
import { useSelector } from "react-redux";

function DashboardStatus({ showSwitch = false }) {
  const { user } = useSelector((state) => state.user);
  console.log(user, "useruser");

  return (
    <Stack
      direction={"row"}
      alignItems={"center"}
      justifyContent={"space-between"}
    >
      <Stack direction={"row"} gap={2} alignItems={"center"}>
        <Avatar
          sx={{ height: { md: "55px" }, width: { md: "55px" } }}
          src={user?.logoImage}
        />
        <Stack>
          <Typography
            variant="h3"
            fontSize={"1rem"}
            fontWeight={600}
            color={appcolors.gunmetal}
          >
            Dashboard
          </Typography>
          <Typography
            variant="body2"
            fontSize={"0.75rem"}
            color={appcolors.crayolaGrey}
          >
            Today : {moment(new Date()).format("DD/MM/YYYY")}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
}

export default DashboardStatus;
